// --
import * as React from 'react';
import classNames from 'classnames';

type Props = {
    className?: string,
    children?: React.ReactNode,
    hover?: boolean, // pokud je true, jedná se o loader, který není jako standardní div, ale objeví se NAD ostatními elementami, napřo pro využití v seznamech apod
};

export const HorizontalLoader = ({className, hover, ...other}: Props) => {
    const clsCont = classNames('loaderInf-container', className, {
        hover,
    });
    const cls = classNames('loaderInf');
    return (
        <div className={clsCont}>
            <div className={cls} {...other}></div>
        </div>
    );
}
